import * as React from "react";
import { useCallback } from "react";
import Routes from "routing/Routes";
import { MenuItem } from "components/bootstrap";
import { isSigmaEventDefinition } from "components/event-definitions/event-definitions-types";
import { useGetSigmaRule } from "security-app/hooks/useSigmaAPI";
import { getRuleTimeRangeSeconds } from "security-app/components/SigmaRules/RowActions";
const SigmaEventDefinitionSearchAction = ({ entity }) => {
  const eventDefinition = entity;
  const isSigma = isSigmaEventDefinition(eventDefinition);
  const sigmaRuleId = isSigma ? eventDefinition.config.sigma_rule_id : void 0;
  const { rule, loadingRule } = useGetSigmaRule(sigmaRuleId);
  const onSearchLogs = useCallback(() => {
    if (!rule) return;
    if (rule.query) {
      const relativeSeconds = getRuleTimeRangeSeconds(rule.search_within, rule.search_within_unit);
      window.open(
        Routes.search_with_query(
          rule.query,
          "relative",
          { relative: relativeSeconds },
          rule.streams,
          rule.stream_categories
        ),
        "_blank"
      );
    } else if (rule.use_event_definition_replay) {
      window.open(Routes.ALERTS.DEFINITIONS.replay_search(eventDefinition.id), "_blank");
    }
  }, [rule, eventDefinition.id]);
  if (!isSigma) return null;
  const canSearch = (rule == null ? void 0 : rule.query) || (rule == null ? void 0 : rule.use_event_definition_replay);
  return /* @__PURE__ */ React.createElement(
    MenuItem,
    {
      disabled: loadingRule || !canSearch,
      onClick: canSearch ? onSearchLogs : void 0
    },
    "Replay Search"
  );
};
export default SigmaEventDefinitionSearchAction;
